import { Grid } from "modules/common/components/Grid";
import { Box, SimpleGrid } from "@chakra-ui/react";
import BestAirlinesByCountry from "./BestAirlinesByCountry";
import BestAirlinesByRegion from "./BestAirlinesByRegion";
import type { BestAirlinesProps } from "./BestAirlines.d";

const BestAirlines = ({ airlinesScoresByCountry, airlinesRegions }: BestAirlinesProps) => (
  <Box bg="greyscale.300" pb={{ base: 0, lg: 24 }}>
    <Grid mb={0} px={{ base: "unset", lg: 4, xl: "unset" }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={{ base: 0, lg: 8 }}>
          <BestAirlinesByCountry airlinesScoresByCountry={airlinesScoresByCountry} />
          <BestAirlinesByRegion airlinesRegions={airlinesRegions} />
        </SimpleGrid>
      </Box>
    </Grid>
  </Box>
);

export default BestAirlines;
